import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { AgoraVideoPlayer } from 'components'

/**
 * Participant: This component is responsible of displaying Participant video and share audio
 * @props {Object} participant The current participant, can be the host or interlocutor
 */
const Participant = ({ videoTrack, className }) => (
  <div className={classnames('w-full h-full overflow-hidden', className)}>
    <AgoraVideoPlayer
      className="object-cover w-full h-full transform scale-x-n1"
      videoTrack={videoTrack}
    />
  </div>
)

Participant.defaultProps = {
  className: 'rounded-full relative',
}

Participant.propTypes = {
  participant: PropTypes.shape({
    videoTrack: PropTypes.shape({}),
    audioTrack: PropTypes.shape({}),
    on: PropTypes.func,
  }),
  className: PropTypes.string,
  tracks: PropTypes.array,
}

export default Participant
